module.exports = "<example-shell\n  exampleId=\"column-sizing\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Column sizing\"\n    [columns]=\"advancedColumns\"\n    [data]=\"orders\"\n    [columnSizing]=\"wideColumnSizingState\"\n    [pagination]=\"true\"\n    [paginationPerPage]=\"5\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/column-sizing/column-sizing.component.html
// module id = ./src/app/examples/column-sizing/column-sizing.component.html
// module chunks = main